<script lang="ts">
export default defineComponent({
  name: 'DialogCloseButton',
  props: {
    as: { type: String, default: 'button'}
  },
  setup ({ as }, { slots }) {
    const { close } = assertInject(DialogInjection)

    const handleClick = (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      close()
    }

    return () => 
      h(
        as,
        {
          onClick: handleClick
        },
        slots.default!()
      )
  }
})
</script>